"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAudioPlayback = exports.AudioPlaybackProvider = exports.AudioPlaybackContext = void 0;

var react_1 = __importDefault(require("react"));

exports.AudioPlaybackContext = react_1.default.createContext(undefined);

function AudioPlaybackProvider(_ref) {
  var children = _ref.children;
  var playingAudioRefs = react_1.default.useRef([]);
  var value = react_1.default.useMemo(function () {
    return {
      startPlaying: function startPlaying(element, silenceOthers) {
        if (silenceOthers) {
          var _iterator = _createForOfIteratorHelper(playingAudioRefs.current),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var ref = _step.value;

              try {
                ref.pause();
              } catch (_a) {// Oh well, couldn't stop playing it...
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          playingAudioRefs.current = [];
        }

        playingAudioRefs.current.push(element);
        element.currentTime = 0;
        element.play();
      }
    };
  }, []);
  return react_1.default.createElement(exports.AudioPlaybackContext.Provider, {
    value: value,
    children: children
  });
}

exports.AudioPlaybackProvider = AudioPlaybackProvider;

function useAudioPlayback(url) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$silenceOthers = _ref2.silenceOthers,
      silenceOthers = _ref2$silenceOthers === void 0 ? true : _ref2$silenceOthers,
      modifyAudio = _ref2.modifyAudio;

  var audioRef = react_1.default.useRef(null);
  react_1.default.useEffect(function () {
    if (url) {
      audioRef.current = new Audio(url);

      if (modifyAudio) {
        modifyAudio(audioRef.current);
      }
    } else {
      audioRef.current = null;
    }
  }, [url]);
  var context = react_1.default.useContext(exports.AudioPlaybackContext);
  return function () {
    if (context) {
      if (audioRef.current) {
        context.startPlaying(audioRef.current, silenceOthers);
      }
    } else {
      console.warn('Cannot useAudioPlayback without AudioPlaybackContext');
    }
  };
}

exports.useAudioPlayback = useAudioPlayback;